import { Injectable, Injector } from '@angular/core';
import { Observable } from 'rxjs';

import { LoginResponse, VertiLogin } from '@models/swagger';
import { ApiService, DefaultHttpHeaders } from '@services/api/api.service';

export interface VertiLoginParams extends DefaultHttpHeaders {}

@Injectable()
export class VertiLoginService extends ApiService {
  constructor(protected readonly injector: Injector) {
    super(injector);
  }

  /**
   * Perform verti login
   * Perform verti login
   * https://d2go64w4712gob.cloudfront.net/swagger/apis_trasversales/italia/api_Verti.html#/Authentication/postVertiLogin
   */
  vertiLogin(body: VertiLogin, params: VertiLoginParams): Observable<LoginResponse> {
    return this.post<VertiLogin, LoginResponse>({
      suffix: '/authentications/myVerti/login',
      body,
    });
  }
}
